import { EvideTableColumn, EvideTableColumnComponent, EvideTableColumnType } from "../common/common.model";

export interface INotificationEventEndpointEmailHttpResponse {
    notificationEventEndPointId: number;
    notificationEventId: number;
    useDefaultSmtpSettings: boolean;
    emailTitle: string;
    emailBody: string;
    smtpHost: string;
    smtpFrom: string;
    smtpUserName: string;
    smtpPassword: string;
    smtpPort: string;
}

export class NotificationEventEndpointEmail {
    constructor(
        public notificationEventEndPointId: number,
        public notificationEventId: number,
        public useDefaultSmtpSettings: boolean,
        public emailTitle: string,
        public emailBody: string,
        public smtpHost: string,
        public smtpFrom: string,
        public smtpUserName: string,
        public smtpPassword: string,
        public smtpPort: string
    ) { }

    public static adapt(data: INotificationEventEndpointEmailHttpResponse) {
        return new this(
            data.notificationEventEndPointId,
            data.notificationEventId,
            data.useDefaultSmtpSettings,
            data.emailTitle,
            data.emailBody,
            data.smtpHost,
            data.smtpFrom,
            data.smtpUserName,
            data.smtpPassword,
            data.smtpPort
        );
    }

    public static createBlank(notificationEventId: number) {
        return new this(0, notificationEventId, true, '', '', '', '', '', '', '');
    }
}

export const NotificationEventEndpointEmailColumns: Readonly<EvideTableColumn[]> = [
    {
        key: 'emailTitle',
        type: EvideTableColumnType.Text,
        compType: EvideTableColumnComponent.Editor,
        isFormField: true,
        isFormEditableField: true,
        title: 'Title',
        displayValue: true,
        required: true,
        required_error: 'Title is Required'
    },
    {
        key: 'emailBody',
        type: EvideTableColumnType.Text,
        compType: EvideTableColumnComponent.Editor,
        isFormField: true,
        isFormEditableField: true,
        title: 'Body',
        displayValue: true,
        required: true,
        required_error: 'Body is Required'
    },
    {
        key: 'useDefaultSmtpSettings',
        type: EvideTableColumnType.Checkbox,
        compType: EvideTableColumnComponent.Input,
        isFormField: true,
        isFormEditableField: true,
        title: 'Use Default Email Settings',
        displayValue: true,
        required: false
    },
    {
        key: 'smtpHost',
        type: EvideTableColumnType.Text,
        compType: EvideTableColumnComponent.Input,
        isFormField: true,
        isFormEditableField: true,
        title: 'Smtp Host',
        displayValue: true,
        required: false,
        displayDynamicInput: true
    },
    {
        key: 'smtpPort',
        type: EvideTableColumnType.Number,
        compType: EvideTableColumnComponent.Input,
        isFormField: true,
        isFormEditableField: true,
        title: 'Smtp Port',
        displayValue: true,
        required: false,
        displayDynamicInput: true
    },
    {
        key: 'smtpFrom',
        type: EvideTableColumnType.String,
        compType: EvideTableColumnComponent.Input,
        isFormField: true,
        isFormEditableField: true,
        title: 'Smtp From',
        displayValue: true,
        required: false,
        displayDynamicInput: true
    },
    {
        key: 'smtpUserName',
        type: EvideTableColumnType.String,
        compType: EvideTableColumnComponent.Input,
        isFormField: true,
        isFormEditableField: true,
        title: 'Smtp User Name',
        displayValue: true,
        required: false,
        displayDynamicInput: true
    },
    {
        key: 'smtpPassword',
        type: EvideTableColumnType.Password,
        compType: EvideTableColumnComponent.Input,
        isFormField: true,
        isFormEditableField: true,
        title: 'Smtp Password',
        displayValue: true,
        required: false,
        displayDynamicInput: true
    }
];